export class ExtensionConfiguration {
  constructor({ extensionId }) {
    this.extensionId = extensionId
  }

  toJson() {
    return {
      extensionId: this.extensionId,
    }
  }
}
